module.exports = __webpack_public_path__ + "img/title3.43cb8f2c.png";